import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EntityService {
  public urlEntities: string = `${environment.apiPrestadorServ.context}${environment.apiPrestadorServ.methods.entities}`;
  public urlEntitiesDetail: string = `${environment.apiPrestadorServ.context}`;

  constructor(private http: HttpClient) {}

  getEntityList(page: number, size: number, search?: string): Promise<any> {
    return this.http
      .get<any>(
        `${this.urlEntities}?size=${size}&page=${page}&search=${search}`
      )
      .toPromise();
  }

  getEntityDetails(id: string): Promise<any> {
    return this.http.get<any>(`${this.urlEntitiesDetail}/${id}`).toPromise();
  }

  getEntityStandard(id: string): Promise<any> {
    return this.http
      .get<any>(`${this.urlEntitiesDetail}${id}/estandares-competencia`)
      .toPromise();
  }
}
